import React from "react";
import PropTypes from "prop-types";
import styles from "./Select.module.scss";

const Select = ({ options, selectRef, ...rest }) => (
  <select className={styles.select} ref={selectRef} {...rest}>
    {options.map(({ value, text, disabled = false }) => (
      <option value={value} key={value}>
        {text}
      </option>
    ))}
  </select>
);

Select.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    })
  ).isRequired,
};

export { Select };
